"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function Svg(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", height: "100%", width: "100%", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 200 200", enableBackground: "new 0 0 200 200", xmlSpace: "preserve" }, props, { children: [(0, jsx_runtime_1.jsxs)("linearGradient", __assign({ id: "SVGID_1_", gradientUnits: "userSpaceOnUse", x1: 149.5981, y1: 152.6356, x2: 51.041, y2: 48.0426 }, { children: [(0, jsx_runtime_1.jsx)("stop", { offset: 0, style: {
                            stopColor: "#DD4362",
                        } }), (0, jsx_runtime_1.jsx)("stop", { offset: 0.5671, style: {
                            stopColor: "#EE633F",
                        } }), (0, jsx_runtime_1.jsx)("stop", { offset: 1, style: {
                            stopColor: "#FB7C24",
                        } })] })), (0, jsx_runtime_1.jsx)("path", { fill: "url(#SVGID_1_)", d: "M100,10L23.4,55.4v89.1L100,190l76.6-45.4V55.4L100,10z M99.8,173.4l-62.4-37V64.3l62.4-37v74 l62.4-37v72.2L99.8,173.4z" })] })));
}
exports.default = Svg;
